// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";           // keep if you have it; remove if not
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
